import {
  SET_PROGRAMAS,
  LOADING,
  ERROR,
  LOADING_LOGIN,
  ERROR_LOGIN,
  SET_USER,
  LOGOUT,
  SWITCH_ADMIN_MENU,
  SET_PROGRAMA_SELECTED,
  SET_PROGRAMA_UPDATED,
  IMAGE_UPLOADED,
  LOADING_IMAGE,
  SET_PROGRAMA_CREATED,
} from './ActionTypes';

export const reducer = (state, action) => {
  switch (action.type) {
    case SET_PROGRAMAS:
      return { ...state, programas: action.payload, loading: false };
    case LOADING:
      return { ...state, loading: true };
    case ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        loadingImage: false,
      };
    case SET_USER:
      return {
        ...state,
        user: action.payload,
        loadingLogin: false,
        errorLogin: null,
      };
    case LOADING_LOGIN:
      return { ...state, loadingLogin: true, errorLogin: null };
    case ERROR_LOGIN:
      return {
        ...state,
        errorLogin: action.payload,
        loadingLogin: false,
        user: null,
      };
    case LOGOUT:
      return { ...state, user: null, loadingLogin: false };
    case SWITCH_ADMIN_MENU:
      return { ...state, menuAdminActivo: action.payload };
    case SET_PROGRAMA_SELECTED:
      return {
        ...state,
        programaSelected: action.payload,
        uploadedImage: null,
      };
    case SET_PROGRAMA_UPDATED:
      return {
        ...state,
        loading: false,
        programas: [
          ...action.listToUpdate.slice(0, action.indexToUpdate),
          action.payload,
          ...action.listToUpdate.slice(action.indexToUpdate + 1),
        ],
      };
    case LOADING_IMAGE:
      return { ...state, loadingImage: true, error: null };
    case IMAGE_UPLOADED:
      return { ...state, loadingImage: false, uploadedImage: action.payload };
    case SET_PROGRAMA_CREATED:
      return {
        ...state,
        programaSelected: action.payload,
        loading: false,
        programas: [...state.programas, action.payload],
      };
    default:
      return state;
  }
};
